import React, {FC} from 'react';
import {useNavigate} from 'react-router';
import {InlineSvg, RsnButton} from '~/library/ui-kit';
import checkIcon from '../../../../../../static/icons/check-line.svg';

const SuccessfullyChangedPasswordPage: FC = () => {
    const navigate = useNavigate();

    const handleLoginClick = () => {
        navigate('/login');
    };

    return (
        <div className='flex h-full flex-col'>
            <div className='flex flex-1 flex-col items-center justify-center gap-6 p-4'>
                <div className='rounded-full bg-success-10 p-[18px] text-[0]'>
                    <InlineSvg src={checkIcon} className='h-[60px] w-[60px] text-success-30' />
                </div>
                <div className='flex flex-col gap-2'>
                    <h2 className='fv-heading-l text-center text-neutral-100'>Password updated</h2>
                    <span className='fv-text-l-regular text-center text-neutral-90'>
                        Your password has been changed successfully.
                        <br />
                        Use your new password to log in.
                    </span>
                </div>
            </div>

            <div className='flex flex-col gap-2 px-4 pb-8'>
                <RsnButton.Primary type='submit' onClick={handleLoginClick}>
                    Log in
                </RsnButton.Primary>
            </div>
        </div>
    );
};

export default SuccessfullyChangedPasswordPage;
